import { render, staticRenderFns } from "./Buscar.vue?vue&type=template&id=63e5c5bd&lang=pug"
import script from "./Buscar.vue?vue&type=script&lang=js"
export * from "./Buscar.vue?vue&type=script&lang=js"
import style0 from "./Buscar.vue?vue&type=style&index=0&id=63e5c5bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports